module.exports = __webpack_public_path__ + "static/media/loading.ecdc0fe3.svg";